/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * EveryStreet.run
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BackfillRequest,
  BulkDeleteMatchedRequest,
  BulkDeleteMatchedStreetsPathParameters,
  BulkDeleteRequest,
  BulkDeleteStreetsPathParameters,
  CheckInvitePathParameters,
  CityRequest,
  CityRequestCreate,
  DeleteWorkspacePathParameters,
  FeatureCollection,
  GenerateSuggestedRoutesPathParameters,
  GetPublicMatchedStreetsPathParameters,
  GetPublicProgressPathParameters,
  GetPublicStatusPathParameters,
  GetPublicStreetsPathParameters,
  GetWorkspacePathParameters,
  HTTPValidationError,
  ImportEventsParams,
  ImportEventsPathParameters,
  InviteRedeem,
  InviteValid,
  ListMatchedStreetsPathParameters,
  ListStravaRunTracksPathParameters,
  ListStravaRunsParams,
  ListStreetsPathParameters,
  ManualMatchRequest,
  MarkStreetsComplete200,
  MarkStreetsCompletePathParameters,
  MarkStreetsIncomplete200,
  MarkStreetsIncompletePathParameters,
  PublicStatus,
  RouteFootPathParameters,
  RouteResult,
  RoutingCity,
  RunTotals,
  ServeStaticMapParams,
  ServeStaticMapPathParameters,
  StravaCallbackParams,
  StravaConnection,
  StravaRunSummary,
  SuggestedRoutesRequest,
  Token,
  UpdateWorkspacePathParameters,
  User,
  UserLogin,
  UserUpdate,
  Workspace,
  WorkspaceCreate,
  WorkspaceProgress,
  WorkspaceUpdate
} from './orval-types';

import { makeRequest } from './httpClient';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Login endpoint
 * @summary Login
 */
export const login = (
    userLogin: UserLogin,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<Token>(
      {url: `/api/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userLogin, signal
    },
      options);
    }
  


export const getLoginMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLogin}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLogin}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: UserLogin}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = UserLogin
    export type LoginMutationError = HTTPValidationError

    /**
 * @summary Login
 */
export const useLogin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLogin}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: UserLogin},
        TContext
      > => {

      const mutationOptions = getLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Logout endpoint (client should discard token)
 * @summary Logout
 */
export const logout = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      options);
    }
  


export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {
          

          return  logout(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>
    
    export type LogoutMutationError = unknown

    /**
 * @summary Logout
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get current user information
 * @summary Get Current User Info
 */
export const getCurrentUserInfo = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<User>(
      {url: `/api/auth/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCurrentUserInfoQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }

    
export const getGetCurrentUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserInfo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserInfo>>> = ({ signal }) => getCurrentUserInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserInfo>>>
export type GetCurrentUserInfoQueryError = unknown


export function useGetCurrentUserInfo<TData = Awaited<ReturnType<typeof getCurrentUserInfo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserInfo<TData = Awaited<ReturnType<typeof getCurrentUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUserInfo<TData = Awaited<ReturnType<typeof getCurrentUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Current User Info
 */

export function useGetCurrentUserInfo<TData = Awaited<ReturnType<typeof getCurrentUserInfo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfo>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserInfoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Record a request for a city we don't support yet.
 * @summary Create City Request
 */
export const createCityRequest = (
    cityRequestCreate: CityRequestCreate,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<CityRequest>(
      {url: `/api/city-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cityRequestCreate, signal
    },
      options);
    }
  


export const getCreateCityRequestMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCityRequest>>, TError,{data: CityRequestCreate}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createCityRequest>>, TError,{data: CityRequestCreate}, TContext> => {

const mutationKey = ['createCityRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCityRequest>>, {data: CityRequestCreate}> = (props) => {
          const {data} = props ?? {};

          return  createCityRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCityRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createCityRequest>>>
    export type CreateCityRequestMutationBody = CityRequestCreate
    export type CreateCityRequestMutationError = HTTPValidationError

    /**
 * @summary Create City Request
 */
export const useCreateCityRequest = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCityRequest>>, TError,{data: CityRequestCreate}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCityRequest>>,
        TError,
        {data: CityRequestCreate},
        TContext
      > => {

      const mutationOptions = getCreateCityRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Redeem a single-use invite: create the account and return an access token.
 * @summary Redeem Invite
 */
export const redeemInvite = (
    inviteRedeem: InviteRedeem,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<Token>(
      {url: `/api/invites/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteRedeem, signal
    },
      options);
    }
  


export const getRedeemInviteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemInvite>>, TError,{data: InviteRedeem}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemInvite>>, TError,{data: InviteRedeem}, TContext> => {

const mutationKey = ['redeemInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemInvite>>, {data: InviteRedeem}> = (props) => {
          const {data} = props ?? {};

          return  redeemInvite(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RedeemInviteMutationResult = NonNullable<Awaited<ReturnType<typeof redeemInvite>>>
    export type RedeemInviteMutationBody = InviteRedeem
    export type RedeemInviteMutationError = HTTPValidationError

    /**
 * @summary Redeem Invite
 */
export const useRedeemInvite = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemInvite>>, TError,{data: InviteRedeem}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemInvite>>,
        TError,
        {data: InviteRedeem},
        TContext
      > => {

      const mutationOptions = getRedeemInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Whether an invite code can still be redeemed (used by the join screen).
 * @summary Check Invite
 */
export const checkInvite = (
    { code }: CheckInvitePathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<InviteValid>(
      {url: `/api/invites/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getCheckInviteQueryKey = ({ code }: CheckInvitePathParameters,) => {
    return [
    `/api/invites/${code}`
    ] as const;
    }

    
export const getCheckInviteQueryOptions = <TData = Awaited<ReturnType<typeof checkInvite>>, TError = HTTPValidationError>({ code }: CheckInvitePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckInviteQueryKey({ code });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkInvite>>> = ({ signal }) => checkInvite({ code }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CheckInviteQueryResult = NonNullable<Awaited<ReturnType<typeof checkInvite>>>
export type CheckInviteQueryError = HTTPValidationError


export function useCheckInvite<TData = Awaited<ReturnType<typeof checkInvite>>, TError = HTTPValidationError>(
 pathParams: CheckInvitePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInvite>>,
          TError,
          Awaited<ReturnType<typeof checkInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckInvite<TData = Awaited<ReturnType<typeof checkInvite>>, TError = HTTPValidationError>(
 pathParams: CheckInvitePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkInvite>>,
          TError,
          Awaited<ReturnType<typeof checkInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCheckInvite<TData = Awaited<ReturnType<typeof checkInvite>>, TError = HTTPValidationError>(
 pathParams: CheckInvitePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Check Invite
 */

export function useCheckInvite<TData = Awaited<ReturnType<typeof checkInvite>>, TError = HTTPValidationError>(
 { code }: CheckInvitePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkInvite>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCheckInviteQueryOptions({ code },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Serve static map HTML file for public profile.

The map is a large self-contained HTML file rebuilt in place whenever a
workspace's coverage changes. To keep it off the server on repeat views,
the unversioned URL redirects to a ``?v=<regen timestamp>`` URL served with
a long immutable cache: browsers reuse it without hitting us, and a regen
changes the token so the new map is fetched exactly once.
 * @summary Serve Static Map
 */
export const serveStaticMap = (
    { username, city }: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/public/${username}/${city}/map.html`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getServeStaticMapQueryKey = ({ username, city }: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams,) => {
    return [
    `/api/public/${username}/${city}/map.html`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getServeStaticMapQueryOptions = <TData = Awaited<ReturnType<typeof serveStaticMap>>, TError = HTTPValidationError>({ username, city }: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getServeStaticMapQueryKey({ username, city },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof serveStaticMap>>> = ({ signal }) => serveStaticMap({ username, city },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username && city), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ServeStaticMapQueryResult = NonNullable<Awaited<ReturnType<typeof serveStaticMap>>>
export type ServeStaticMapQueryError = HTTPValidationError


export function useServeStaticMap<TData = Awaited<ReturnType<typeof serveStaticMap>>, TError = HTTPValidationError>(
 pathParams: ServeStaticMapPathParameters,
    params: undefined |  ServeStaticMapParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveStaticMap>>,
          TError,
          Awaited<ReturnType<typeof serveStaticMap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServeStaticMap<TData = Awaited<ReturnType<typeof serveStaticMap>>, TError = HTTPValidationError>(
 pathParams: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof serveStaticMap>>,
          TError,
          Awaited<ReturnType<typeof serveStaticMap>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useServeStaticMap<TData = Awaited<ReturnType<typeof serveStaticMap>>, TError = HTTPValidationError>(
 pathParams: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Serve Static Map
 */

export function useServeStaticMap<TData = Awaited<ReturnType<typeof serveStaticMap>>, TError = HTTPValidationError>(
 { username, city }: ServeStaticMapPathParameters,
    params?: ServeStaticMapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof serveStaticMap>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getServeStaticMapQueryOptions({ username, city },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get matched streets for a public profile
 * @summary Get Public Matched Streets
 */
export const getPublicMatchedStreets = (
    { username, city }: GetPublicMatchedStreetsPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/public/${username}/${city}/matched-streets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicMatchedStreetsQueryKey = ({ username, city }: GetPublicMatchedStreetsPathParameters,) => {
    return [
    `/api/public/${username}/${city}/matched-streets`
    ] as const;
    }

    
export const getGetPublicMatchedStreetsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError = HTTPValidationError>({ username, city }: GetPublicMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicMatchedStreetsQueryKey({ username, city });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicMatchedStreets>>> = ({ signal }) => getPublicMatchedStreets({ username, city }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username && city), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicMatchedStreetsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicMatchedStreets>>>
export type GetPublicMatchedStreetsQueryError = HTTPValidationError


export function useGetPublicMatchedStreets<TData = Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicMatchedStreetsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMatchedStreets>>,
          TError,
          Awaited<ReturnType<typeof getPublicMatchedStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMatchedStreets<TData = Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicMatchedStreets>>,
          TError,
          Awaited<ReturnType<typeof getPublicMatchedStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicMatchedStreets<TData = Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Matched Streets
 */

export function useGetPublicMatchedStreets<TData = Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError = HTTPValidationError>(
 { username, city }: GetPublicMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicMatchedStreetsQueryOptions({ username, city },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get progress stats for a public profile
 * @summary Get Public Progress
 */
export const getPublicProgress = (
    { username, city }: GetPublicProgressPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<WorkspaceProgress>(
      {url: `/api/public/${username}/${city}/progress`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicProgressQueryKey = ({ username, city }: GetPublicProgressPathParameters,) => {
    return [
    `/api/public/${username}/${city}/progress`
    ] as const;
    }

    
export const getGetPublicProgressQueryOptions = <TData = Awaited<ReturnType<typeof getPublicProgress>>, TError = HTTPValidationError>({ username, city }: GetPublicProgressPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicProgressQueryKey({ username, city });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicProgress>>> = ({ signal }) => getPublicProgress({ username, city }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username && city), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicProgress>>>
export type GetPublicProgressQueryError = HTTPValidationError


export function useGetPublicProgress<TData = Awaited<ReturnType<typeof getPublicProgress>>, TError = HTTPValidationError>(
 pathParams: GetPublicProgressPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicProgress>>,
          TError,
          Awaited<ReturnType<typeof getPublicProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicProgress<TData = Awaited<ReturnType<typeof getPublicProgress>>, TError = HTTPValidationError>(
 pathParams: GetPublicProgressPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicProgress>>,
          TError,
          Awaited<ReturnType<typeof getPublicProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicProgress<TData = Awaited<ReturnType<typeof getPublicProgress>>, TError = HTTPValidationError>(
 pathParams: GetPublicProgressPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Progress
 */

export function useGetPublicProgress<TData = Awaited<ReturnType<typeof getPublicProgress>>, TError = HTTPValidationError>(
 { username, city }: GetPublicProgressPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicProgress>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicProgressQueryOptions({ username, city },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get streets for a public profile
 * @summary Get Public Streets
 */
export const getPublicStreets = (
    { username, city }: GetPublicStreetsPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/public/${username}/${city}/streets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicStreetsQueryKey = ({ username, city }: GetPublicStreetsPathParameters,) => {
    return [
    `/api/public/${username}/${city}/streets`
    ] as const;
    }

    
export const getGetPublicStreetsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicStreets>>, TError = HTTPValidationError>({ username, city }: GetPublicStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicStreetsQueryKey({ username, city });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicStreets>>> = ({ signal }) => getPublicStreets({ username, city }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username && city), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicStreetsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicStreets>>>
export type GetPublicStreetsQueryError = HTTPValidationError


export function useGetPublicStreets<TData = Awaited<ReturnType<typeof getPublicStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicStreetsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStreets>>,
          TError,
          Awaited<ReturnType<typeof getPublicStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStreets<TData = Awaited<ReturnType<typeof getPublicStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStreets>>,
          TError,
          Awaited<ReturnType<typeof getPublicStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStreets<TData = Awaited<ReturnType<typeof getPublicStreets>>, TError = HTTPValidationError>(
 pathParams: GetPublicStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Streets
 */

export function useGetPublicStreets<TData = Awaited<ReturnType<typeof getPublicStreets>>, TError = HTTPValidationError>(
 { username, city }: GetPublicStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicStreetsQueryOptions({ username, city },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Compute a foot route via the internal OSRM server.

`coordinates` is OSRM's `lon,lat;lon,lat;...` segment. Returns a normalized
result (code, distance in meters, GeoJSON geometry) rather than OSRM's raw
response shape.
 * @summary Route Foot
 */
export const routeFoot = (
    { coordinates }: RouteFootPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<RouteResult>(
      {url: `/api/routing/foot/${coordinates}`, method: 'GET', signal
    },
      options);
    }
  



export const getRouteFootQueryKey = ({ coordinates }: RouteFootPathParameters,) => {
    return [
    `/api/routing/foot/${coordinates}`
    ] as const;
    }

    
export const getRouteFootQueryOptions = <TData = Awaited<ReturnType<typeof routeFoot>>, TError = HTTPValidationError>({ coordinates }: RouteFootPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRouteFootQueryKey({ coordinates });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof routeFoot>>> = ({ signal }) => routeFoot({ coordinates }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coordinates), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RouteFootQueryResult = NonNullable<Awaited<ReturnType<typeof routeFoot>>>
export type RouteFootQueryError = HTTPValidationError


export function useRouteFoot<TData = Awaited<ReturnType<typeof routeFoot>>, TError = HTTPValidationError>(
 pathParams: RouteFootPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof routeFoot>>,
          TError,
          Awaited<ReturnType<typeof routeFoot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRouteFoot<TData = Awaited<ReturnType<typeof routeFoot>>, TError = HTTPValidationError>(
 pathParams: RouteFootPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof routeFoot>>,
          TError,
          Awaited<ReturnType<typeof routeFoot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRouteFoot<TData = Awaited<ReturnType<typeof routeFoot>>, TError = HTTPValidationError>(
 pathParams: RouteFootPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Route Foot
 */

export function useRouteFoot<TData = Awaited<ReturnType<typeof routeFoot>>, TError = HTTPValidationError>(
 { coordinates }: RouteFootPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof routeFoot>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRouteFootQueryOptions({ coordinates },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Cities served by self-hosted OSRM.
 * @summary List Supported Cities
 */
export const listSupportedCities = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<RoutingCity[]>(
      {url: `/api/routing/supported`, method: 'GET', signal
    },
      options);
    }
  



export const getListSupportedCitiesQueryKey = () => {
    return [
    `/api/routing/supported`
    ] as const;
    }

    
export const getListSupportedCitiesQueryOptions = <TData = Awaited<ReturnType<typeof listSupportedCities>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupportedCitiesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupportedCities>>> = ({ signal }) => listSupportedCities(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSupportedCitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listSupportedCities>>>
export type ListSupportedCitiesQueryError = unknown


export function useListSupportedCities<TData = Awaited<ReturnType<typeof listSupportedCities>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportedCities>>,
          TError,
          Awaited<ReturnType<typeof listSupportedCities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportedCities<TData = Awaited<ReturnType<typeof listSupportedCities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportedCities>>,
          TError,
          Awaited<ReturnType<typeof listSupportedCities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportedCities<TData = Awaited<ReturnType<typeof listSupportedCities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Supported Cities
 */

export function useListSupportedCities<TData = Awaited<ReturnType<typeof listSupportedCities>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportedCities>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSupportedCitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List the user's runs across all their cities, newest first, paginated.

Returns lightweight summaries (no track geometry). ``defer`` keeps the WKB
geometry column from being loaded from Postgres at all.
 * @summary List Strava Runs
 */
export const listStravaRuns = (
    params?: ListStravaRunsParams,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<StravaRunSummary[]>(
      {url: `/api/runs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListStravaRunsQueryKey = (params?: ListStravaRunsParams,) => {
    return [
    `/api/runs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListStravaRunsQueryOptions = <TData = Awaited<ReturnType<typeof listStravaRuns>>, TError = HTTPValidationError>(params?: ListStravaRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStravaRunsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStravaRuns>>> = ({ signal }) => listStravaRuns(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStravaRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listStravaRuns>>>
export type ListStravaRunsQueryError = HTTPValidationError


export function useListStravaRuns<TData = Awaited<ReturnType<typeof listStravaRuns>>, TError = HTTPValidationError>(
 params: undefined |  ListStravaRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaRuns>>,
          TError,
          Awaited<ReturnType<typeof listStravaRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaRuns<TData = Awaited<ReturnType<typeof listStravaRuns>>, TError = HTTPValidationError>(
 params?: ListStravaRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaRuns>>,
          TError,
          Awaited<ReturnType<typeof listStravaRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaRuns<TData = Awaited<ReturnType<typeof listStravaRuns>>, TError = HTTPValidationError>(
 params?: ListStravaRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Strava Runs
 */

export function useListStravaRuns<TData = Awaited<ReturnType<typeof listStravaRuns>>, TError = HTTPValidationError>(
 params?: ListStravaRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRuns>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStravaRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Year-to-date running totals across all of the user's cities.
 * @summary Get Run Totals
 */
export const getRunTotals = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<RunTotals>(
      {url: `/api/runs/totals`, method: 'GET', signal
    },
      options);
    }
  



export const getGetRunTotalsQueryKey = () => {
    return [
    `/api/runs/totals`
    ] as const;
    }

    
export const getGetRunTotalsQueryOptions = <TData = Awaited<ReturnType<typeof getRunTotals>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunTotalsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRunTotals>>> = ({ signal }) => getRunTotals(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunTotalsQueryResult = NonNullable<Awaited<ReturnType<typeof getRunTotals>>>
export type GetRunTotalsQueryError = unknown


export function useGetRunTotals<TData = Awaited<ReturnType<typeof getRunTotals>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunTotals>>,
          TError,
          Awaited<ReturnType<typeof getRunTotals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunTotals<TData = Awaited<ReturnType<typeof getRunTotals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunTotals>>,
          TError,
          Awaited<ReturnType<typeof getRunTotals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunTotals<TData = Awaited<ReturnType<typeof getRunTotals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Run Totals
 */

export function useGetRunTotals<TData = Awaited<ReturnType<typeof getRunTotals>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunTotals>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunTotalsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List the current user's Strava connection (one per user).
 * @summary List Strava Apps
 */
export const listStravaApps = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<StravaConnection[]>(
      {url: `/api/strava`, method: 'GET', signal
    },
      options);
    }
  



export const getListStravaAppsQueryKey = () => {
    return [
    `/api/strava`
    ] as const;
    }

    
export const getListStravaAppsQueryOptions = <TData = Awaited<ReturnType<typeof listStravaApps>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStravaAppsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStravaApps>>> = ({ signal }) => listStravaApps(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStravaAppsQueryResult = NonNullable<Awaited<ReturnType<typeof listStravaApps>>>
export type ListStravaAppsQueryError = unknown


export function useListStravaApps<TData = Awaited<ReturnType<typeof listStravaApps>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaApps>>,
          TError,
          Awaited<ReturnType<typeof listStravaApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaApps<TData = Awaited<ReturnType<typeof listStravaApps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaApps>>,
          TError,
          Awaited<ReturnType<typeof listStravaApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaApps<TData = Awaited<ReturnType<typeof listStravaApps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Strava Apps
 */

export function useListStravaApps<TData = Awaited<ReturnType<typeof listStravaApps>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaApps>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStravaAppsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Queue an import of the user's recent runs (onboarding fill-in).
 * @summary Backfill Strava
 */
export const backfillStrava = (
    backfillRequest: BackfillRequest,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/strava/activities:import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: backfillRequest, signal
    },
      options);
    }
  


export const getBackfillStravaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backfillStrava>>, TError,{data: BackfillRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backfillStrava>>, TError,{data: BackfillRequest}, TContext> => {

const mutationKey = ['backfillStrava'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backfillStrava>>, {data: BackfillRequest}> = (props) => {
          const {data} = props ?? {};

          return  backfillStrava(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BackfillStravaMutationResult = NonNullable<Awaited<ReturnType<typeof backfillStrava>>>
    export type BackfillStravaMutationBody = BackfillRequest
    export type BackfillStravaMutationError = HTTPValidationError

    /**
 * @summary Backfill Strava
 */
export const useBackfillStrava = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backfillStrava>>, TError,{data: BackfillRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backfillStrava>>,
        TError,
        {data: BackfillRequest},
        TContext
      > => {

      const mutationOptions = getBackfillStravaMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Initiate Strava OAuth flow
 * @summary Strava Auth
 */
export const stravaAuth = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/strava/auth`, method: 'GET', signal
    },
      options);
    }
  



export const getStravaAuthQueryKey = () => {
    return [
    `/api/strava/auth`
    ] as const;
    }

    
export const getStravaAuthQueryOptions = <TData = Awaited<ReturnType<typeof stravaAuth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStravaAuthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stravaAuth>>> = ({ signal }) => stravaAuth(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StravaAuthQueryResult = NonNullable<Awaited<ReturnType<typeof stravaAuth>>>
export type StravaAuthQueryError = unknown


export function useStravaAuth<TData = Awaited<ReturnType<typeof stravaAuth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaAuth>>,
          TError,
          Awaited<ReturnType<typeof stravaAuth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaAuth<TData = Awaited<ReturnType<typeof stravaAuth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaAuth>>,
          TError,
          Awaited<ReturnType<typeof stravaAuth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaAuth<TData = Awaited<ReturnType<typeof stravaAuth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Strava Auth
 */

export function useStravaAuth<TData = Awaited<ReturnType<typeof stravaAuth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaAuth>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStravaAuthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Handle Strava OAuth callback
 * @summary Strava Callback
 */
export const stravaCallback = (
    params: StravaCallbackParams,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<string>(
      {url: `/api/strava/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getStravaCallbackQueryKey = (params?: StravaCallbackParams,) => {
    return [
    `/api/strava/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStravaCallbackQueryOptions = <TData = Awaited<ReturnType<typeof stravaCallback>>, TError = HTTPValidationError>(params: StravaCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStravaCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stravaCallback>>> = ({ signal }) => stravaCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StravaCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof stravaCallback>>>
export type StravaCallbackQueryError = HTTPValidationError


export function useStravaCallback<TData = Awaited<ReturnType<typeof stravaCallback>>, TError = HTTPValidationError>(
 params: StravaCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaCallback>>,
          TError,
          Awaited<ReturnType<typeof stravaCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaCallback<TData = Awaited<ReturnType<typeof stravaCallback>>, TError = HTTPValidationError>(
 params: StravaCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaCallback>>,
          TError,
          Awaited<ReturnType<typeof stravaCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaCallback<TData = Awaited<ReturnType<typeof stravaCallback>>, TError = HTTPValidationError>(
 params: StravaCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Strava Callback
 */

export function useStravaCallback<TData = Awaited<ReturnType<typeof stravaCallback>>, TError = HTTPValidationError>(
 params: StravaCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaCallback>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStravaCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Disconnect (deauthorize) the user's Strava connection.
 * @summary Disconnect Strava
 */
export const disconnectStrava = (
    
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<void>(
      {url: `/api/strava/connection`, method: 'DELETE'
    },
      options);
    }
  


export const getDisconnectStravaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectStrava>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectStrava>>, TError,void, TContext> => {

const mutationKey = ['disconnectStrava'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectStrava>>, void> = () => {
          

          return  disconnectStrava(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisconnectStravaMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectStrava>>>
    
    export type DisconnectStravaMutationError = unknown

    /**
 * @summary Disconnect Strava
 */
export const useDisconnectStrava = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectStrava>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectStrava>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDisconnectStravaMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Server-sent events stream of an import's progress.

Auth is the short-lived token from the import response (query param, since
EventSource can't set headers); its `imp` claim must match this import.
 * @summary Import Events
 */
export const importEvents = (
    { importId }: ImportEventsPathParameters,
    params: ImportEventsParams,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/strava/imports/${importId}/events`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getImportEventsQueryKey = ({ importId }: ImportEventsPathParameters,
    params?: ImportEventsParams,) => {
    return [
    `/api/strava/imports/${importId}/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getImportEventsQueryOptions = <TData = Awaited<ReturnType<typeof importEvents>>, TError = HTTPValidationError>({ importId }: ImportEventsPathParameters,
    params: ImportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportEventsQueryKey({ importId },params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importEvents>>> = ({ signal }) => importEvents({ importId },params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(importId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ImportEventsQueryResult = NonNullable<Awaited<ReturnType<typeof importEvents>>>
export type ImportEventsQueryError = HTTPValidationError


export function useImportEvents<TData = Awaited<ReturnType<typeof importEvents>>, TError = HTTPValidationError>(
 pathParams: ImportEventsPathParameters,
    params: ImportEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof importEvents>>,
          TError,
          Awaited<ReturnType<typeof importEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImportEvents<TData = Awaited<ReturnType<typeof importEvents>>, TError = HTTPValidationError>(
 pathParams: ImportEventsPathParameters,
    params: ImportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof importEvents>>,
          TError,
          Awaited<ReturnType<typeof importEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useImportEvents<TData = Awaited<ReturnType<typeof importEvents>>, TError = HTTPValidationError>(
 pathParams: ImportEventsPathParameters,
    params: ImportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Import Events
 */

export function useImportEvents<TData = Awaited<ReturnType<typeof importEvents>>, TError = HTTPValidationError>(
 { importId }: ImportEventsPathParameters,
    params: ImportEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importEvents>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportEventsQueryOptions({ importId },params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Strava webhook subscription validation handshake.

Strava sends hub.mode / hub.verify_token / hub.challenge as query params
(dotted names, so we read them off the request directly).
 * @summary Strava Webhook Verify
 */
export const stravaWebhookVerify = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/strava/webhook`, method: 'GET', signal
    },
      options);
    }
  



export const getStravaWebhookVerifyQueryKey = () => {
    return [
    `/api/strava/webhook`
    ] as const;
    }

    
export const getStravaWebhookVerifyQueryOptions = <TData = Awaited<ReturnType<typeof stravaWebhookVerify>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStravaWebhookVerifyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof stravaWebhookVerify>>> = ({ signal }) => stravaWebhookVerify(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StravaWebhookVerifyQueryResult = NonNullable<Awaited<ReturnType<typeof stravaWebhookVerify>>>
export type StravaWebhookVerifyQueryError = unknown


export function useStravaWebhookVerify<TData = Awaited<ReturnType<typeof stravaWebhookVerify>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaWebhookVerify>>,
          TError,
          Awaited<ReturnType<typeof stravaWebhookVerify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaWebhookVerify<TData = Awaited<ReturnType<typeof stravaWebhookVerify>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof stravaWebhookVerify>>,
          TError,
          Awaited<ReturnType<typeof stravaWebhookVerify>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStravaWebhookVerify<TData = Awaited<ReturnType<typeof stravaWebhookVerify>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Strava Webhook Verify
 */

export function useStravaWebhookVerify<TData = Awaited<ReturnType<typeof stravaWebhookVerify>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stravaWebhookVerify>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStravaWebhookVerifyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Receive Strava webhook events and enqueue processing.

Returns 200 immediately so Strava does not retry or disable the subscription.
 * @summary Strava Webhook Event
 */
export const stravaWebhookEvent = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/api/strava/webhook`, method: 'POST', signal
    },
      options);
    }
  


export const getStravaWebhookEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stravaWebhookEvent>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof stravaWebhookEvent>>, TError,void, TContext> => {

const mutationKey = ['stravaWebhookEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stravaWebhookEvent>>, void> = () => {
          

          return  stravaWebhookEvent(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StravaWebhookEventMutationResult = NonNullable<Awaited<ReturnType<typeof stravaWebhookEvent>>>
    
    export type StravaWebhookEventMutationError = unknown

    /**
 * @summary Strava Webhook Event
 */
export const useStravaWebhookEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stravaWebhookEvent>>, TError,void, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stravaWebhookEvent>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getStravaWebhookEventMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get current user with workspaces
 * @summary Read Users Me
 */
export const readUsersMe = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<User>(
      {url: `/api/users/me`, method: 'GET', signal
    },
      options);
    }
  



export const getReadUsersMeQueryKey = () => {
    return [
    `/api/users/me`
    ] as const;
    }

    
export const getReadUsersMeQueryOptions = <TData = Awaited<ReturnType<typeof readUsersMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadUsersMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof readUsersMe>>> = ({ signal }) => readUsersMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReadUsersMeQueryResult = NonNullable<Awaited<ReturnType<typeof readUsersMe>>>
export type ReadUsersMeQueryError = unknown


export function useReadUsersMe<TData = Awaited<ReturnType<typeof readUsersMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readUsersMe>>,
          TError,
          Awaited<ReturnType<typeof readUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadUsersMe<TData = Awaited<ReturnType<typeof readUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readUsersMe>>,
          TError,
          Awaited<ReturnType<typeof readUsersMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReadUsersMe<TData = Awaited<ReturnType<typeof readUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read Users Me
 */

export function useReadUsersMe<TData = Awaited<ReturnType<typeof readUsersMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof readUsersMe>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReadUsersMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update current user
 * @summary Update User Me
 */
export const updateUserMe = (
    userUpdate: UserUpdate,
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<User>(
      {url: `/api/users/me`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userUpdate
    },
      options);
    }
  


export const getUpdateUserMeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserMe>>, TError,{data: UserUpdate}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserMe>>, TError,{data: UserUpdate}, TContext> => {

const mutationKey = ['updateUserMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserMe>>, {data: UserUpdate}> = (props) => {
          const {data} = props ?? {};

          return  updateUserMe(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserMe>>>
    export type UpdateUserMeMutationBody = UserUpdate
    export type UpdateUserMeMutationError = HTTPValidationError

    /**
 * @summary Update User Me
 */
export const useUpdateUserMe = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserMe>>, TError,{data: UserUpdate}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserMe>>,
        TError,
        {data: UserUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateUserMeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Whether a user has a public profile (used before linking to their page).
 * @summary Get Public Status
 */
export const getPublicStatus = (
    { username }: GetPublicStatusPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<PublicStatus>(
      {url: `/api/users/${username}/public-status`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicStatusQueryKey = ({ username }: GetPublicStatusPathParameters,) => {
    return [
    `/api/users/${username}/public-status`
    ] as const;
    }

    
export const getGetPublicStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPublicStatus>>, TError = HTTPValidationError>({ username }: GetPublicStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicStatusQueryKey({ username });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicStatus>>> = ({ signal }) => getPublicStatus({ username }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(username), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicStatus>>>
export type GetPublicStatusQueryError = HTTPValidationError


export function useGetPublicStatus<TData = Awaited<ReturnType<typeof getPublicStatus>>, TError = HTTPValidationError>(
 pathParams: GetPublicStatusPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStatus>>,
          TError,
          Awaited<ReturnType<typeof getPublicStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStatus<TData = Awaited<ReturnType<typeof getPublicStatus>>, TError = HTTPValidationError>(
 pathParams: GetPublicStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicStatus>>,
          TError,
          Awaited<ReturnType<typeof getPublicStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicStatus<TData = Awaited<ReturnType<typeof getPublicStatus>>, TError = HTTPValidationError>(
 pathParams: GetPublicStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Public Status
 */

export function useGetPublicStatus<TData = Awaited<ReturnType<typeof getPublicStatus>>, TError = HTTPValidationError>(
 { username }: GetPublicStatusPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicStatus>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicStatusQueryOptions({ username },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List all workspaces for current user
 * @summary List Workspaces
 */
export const listWorkspaces = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<Workspace[]>(
      {url: `/api/workspaces`, method: 'GET', signal
    },
      options);
    }
  



export const getListWorkspacesQueryKey = () => {
    return [
    `/api/workspaces`
    ] as const;
    }

    
export const getListWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspacesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaces>>> = ({ signal }) => listWorkspaces(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaces>>>
export type ListWorkspacesQueryError = unknown


export function useListWorkspaces<TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkspaces<TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWorkspaces>>,
          TError,
          Awaited<ReturnType<typeof listWorkspaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWorkspaces<TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Workspaces
 */

export function useListWorkspaces<TData = Awaited<ReturnType<typeof listWorkspaces>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorkspaces>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWorkspacesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new workspace, attaching it to the shared city for its place.
 * @summary Create Workspace
 */
export const createWorkspace = (
    workspaceCreate: WorkspaceCreate,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<Workspace>(
      {url: `/api/workspaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceCreate, signal
    },
      options);
    }
  


export const getCreateWorkspaceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: WorkspaceCreate}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: WorkspaceCreate}, TContext> => {

const mutationKey = ['createWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspace>>, {data: WorkspaceCreate}> = (props) => {
          const {data} = props ?? {};

          return  createWorkspace(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspace>>>
    export type CreateWorkspaceMutationBody = WorkspaceCreate
    export type CreateWorkspaceMutationError = HTTPValidationError

    /**
 * @summary Create Workspace
 */
export const useCreateWorkspace = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{data: WorkspaceCreate}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspace>>,
        TError,
        {data: WorkspaceCreate},
        TContext
      > => {

      const mutationOptions = getCreateWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a workspace
 * @summary Delete Workspace
 */
export const deleteWorkspace = (
    { workspaceId }: DeleteWorkspacePathParameters,
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<void>(
      {url: `/api/workspaces/${workspaceId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteWorkspaceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{pathParams: DeleteWorkspacePathParameters}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{pathParams: DeleteWorkspacePathParameters}, TContext> => {

const mutationKey = ['deleteWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorkspace>>, {pathParams: DeleteWorkspacePathParameters}> = (props) => {
          const {pathParams} = props ?? {};

          return  deleteWorkspace(pathParams,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorkspace>>>
    
    export type DeleteWorkspaceMutationError = HTTPValidationError

    /**
 * @summary Delete Workspace
 */
export const useDeleteWorkspace = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorkspace>>, TError,{pathParams: DeleteWorkspacePathParameters}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWorkspace>>,
        TError,
        {pathParams: DeleteWorkspacePathParameters},
        TContext
      > => {

      const mutationOptions = getDeleteWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a specific workspace with progress data
 * @summary Get Workspace
 */
export const getWorkspace = (
    { workspaceId }: GetWorkspacePathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<Workspace>(
      {url: `/api/workspaces/${workspaceId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWorkspaceQueryKey = ({ workspaceId }: GetWorkspacePathParameters,) => {
    return [
    `/api/workspaces/${workspaceId}`
    ] as const;
    }

    
export const getGetWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspace>>, TError = HTTPValidationError>({ workspaceId }: GetWorkspacePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceQueryKey({ workspaceId });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspace>>> = ({ signal }) => getWorkspace({ workspaceId }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspace>>>
export type GetWorkspaceQueryError = HTTPValidationError


export function useGetWorkspace<TData = Awaited<ReturnType<typeof getWorkspace>>, TError = HTTPValidationError>(
 pathParams: GetWorkspacePathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspace<TData = Awaited<ReturnType<typeof getWorkspace>>, TError = HTTPValidationError>(
 pathParams: GetWorkspacePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspace<TData = Awaited<ReturnType<typeof getWorkspace>>, TError = HTTPValidationError>(
 pathParams: GetWorkspacePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Workspace
 */

export function useGetWorkspace<TData = Awaited<ReturnType<typeof getWorkspace>>, TError = HTTPValidationError>(
 { workspaceId }: GetWorkspacePathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspace>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceQueryOptions({ workspaceId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update a workspace
 * @summary Update Workspace
 */
export const updateWorkspace = (
    { workspaceId }: UpdateWorkspacePathParameters,
    workspaceUpdate: WorkspaceUpdate,
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<Workspace>(
      {url: `/api/workspaces/${workspaceId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workspaceUpdate
    },
      options);
    }
  


export const getUpdateWorkspaceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{pathParams: UpdateWorkspacePathParameters;data: WorkspaceUpdate}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{pathParams: UpdateWorkspacePathParameters;data: WorkspaceUpdate}, TContext> => {

const mutationKey = ['updateWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkspace>>, {pathParams: UpdateWorkspacePathParameters;data: WorkspaceUpdate}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  updateWorkspace(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorkspace>>>
    export type UpdateWorkspaceMutationBody = WorkspaceUpdate
    export type UpdateWorkspaceMutationError = HTTPValidationError

    /**
 * @summary Update Workspace
 */
export const useUpdateWorkspace = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorkspace>>, TError,{pathParams: UpdateWorkspacePathParameters;data: WorkspaceUpdate}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateWorkspace>>,
        TError,
        {pathParams: UpdateWorkspacePathParameters;data: WorkspaceUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete matched-street coverage rows by ID for the current workspace. Admin only.

Used by the delete tool to clear orphaned coverage (matched streets whose
street was hidden) that the incomplete brush can no longer reach.
 * @summary Bulk Delete Matched Streets
 */
export const bulkDeleteMatchedStreets = (
    { workspaceId }: BulkDeleteMatchedStreetsPathParameters,
    bulkDeleteMatchedRequest: BulkDeleteMatchedRequest,
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<void>(
      {url: `/api/workspaces/${workspaceId}/matched-streets`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteMatchedRequest
    },
      options);
    }
  


export const getBulkDeleteMatchedStreetsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>, TError,{pathParams: BulkDeleteMatchedStreetsPathParameters;data: BulkDeleteMatchedRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>, TError,{pathParams: BulkDeleteMatchedStreetsPathParameters;data: BulkDeleteMatchedRequest}, TContext> => {

const mutationKey = ['bulkDeleteMatchedStreets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>, {pathParams: BulkDeleteMatchedStreetsPathParameters;data: BulkDeleteMatchedRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  bulkDeleteMatchedStreets(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteMatchedStreetsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>>
    export type BulkDeleteMatchedStreetsMutationBody = BulkDeleteMatchedRequest
    export type BulkDeleteMatchedStreetsMutationError = HTTPValidationError

    /**
 * @summary Bulk Delete Matched Streets
 */
export const useBulkDeleteMatchedStreets = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>, TError,{pathParams: BulkDeleteMatchedStreetsPathParameters;data: BulkDeleteMatchedRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteMatchedStreets>>,
        TError,
        {pathParams: BulkDeleteMatchedStreetsPathParameters;data: BulkDeleteMatchedRequest},
        TContext
      > => {

      const mutationOptions = getBulkDeleteMatchedStreetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List matched streets for the current workspace as a GeoJSON FeatureCollection.
 * @summary List Matched Streets
 */
export const listMatchedStreets = (
    { workspaceId }: ListMatchedStreetsPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/workspaces/${workspaceId}/matched-streets`, method: 'GET', signal
    },
      options);
    }
  



export const getListMatchedStreetsQueryKey = ({ workspaceId }: ListMatchedStreetsPathParameters,) => {
    return [
    `/api/workspaces/${workspaceId}/matched-streets`
    ] as const;
    }

    
export const getListMatchedStreetsQueryOptions = <TData = Awaited<ReturnType<typeof listMatchedStreets>>, TError = HTTPValidationError>({ workspaceId }: ListMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMatchedStreetsQueryKey({ workspaceId });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMatchedStreets>>> = ({ signal }) => listMatchedStreets({ workspaceId }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMatchedStreetsQueryResult = NonNullable<Awaited<ReturnType<typeof listMatchedStreets>>>
export type ListMatchedStreetsQueryError = HTTPValidationError


export function useListMatchedStreets<TData = Awaited<ReturnType<typeof listMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: ListMatchedStreetsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMatchedStreets>>,
          TError,
          Awaited<ReturnType<typeof listMatchedStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMatchedStreets<TData = Awaited<ReturnType<typeof listMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: ListMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMatchedStreets>>,
          TError,
          Awaited<ReturnType<typeof listMatchedStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMatchedStreets<TData = Awaited<ReturnType<typeof listMatchedStreets>>, TError = HTTPValidationError>(
 pathParams: ListMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Matched Streets
 */

export function useListMatchedStreets<TData = Awaited<ReturnType<typeof listMatchedStreets>>, TError = HTTPValidationError>(
 { workspaceId }: ListMatchedStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMatchedStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMatchedStreetsQueryOptions({ workspaceId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Manually mark street segments as completed with specific geometry

Follows the same merging logic as the Strava matcher:
- Groups segments by street_id
- Merges overlapping/nearby segments using unary_union
- Updates existing matched streets or creates new ones
 * @summary Mark Streets Complete
 */
export const markStreetsComplete = (
    { workspaceId }: MarkStreetsCompletePathParameters,
    manualMatchRequest: ManualMatchRequest,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<MarkStreetsComplete200>(
      {url: `/api/workspaces/${workspaceId}/matched-streets:complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manualMatchRequest, signal
    },
      options);
    }
  


export const getMarkStreetsCompleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markStreetsComplete>>, TError,{pathParams: MarkStreetsCompletePathParameters;data: ManualMatchRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof markStreetsComplete>>, TError,{pathParams: MarkStreetsCompletePathParameters;data: ManualMatchRequest}, TContext> => {

const mutationKey = ['markStreetsComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markStreetsComplete>>, {pathParams: MarkStreetsCompletePathParameters;data: ManualMatchRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  markStreetsComplete(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkStreetsCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markStreetsComplete>>>
    export type MarkStreetsCompleteMutationBody = ManualMatchRequest
    export type MarkStreetsCompleteMutationError = HTTPValidationError

    /**
 * @summary Mark Streets Complete
 */
export const useMarkStreetsComplete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markStreetsComplete>>, TError,{pathParams: MarkStreetsCompletePathParameters;data: ManualMatchRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markStreetsComplete>>,
        TError,
        {pathParams: MarkStreetsCompletePathParameters;data: ManualMatchRequest},
        TContext
      > => {

      const mutationOptions = getMarkStreetsCompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Mark brushed sub-segments incomplete (the inverse of /complete).

Mirrors the completion tool: the brushed segments are intersected with the
street's own geometry, and that on-street portion is subtracted from every
matched-street row for the street. Rows that fall to ~zero coverage are
deleted, and workspace progress is recomputed afterwards.
 * @summary Mark Streets Incomplete
 */
export const markStreetsIncomplete = (
    { workspaceId }: MarkStreetsIncompletePathParameters,
    manualMatchRequest: ManualMatchRequest,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<MarkStreetsIncomplete200>(
      {url: `/api/workspaces/${workspaceId}/matched-streets:incomplete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manualMatchRequest, signal
    },
      options);
    }
  


export const getMarkStreetsIncompleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markStreetsIncomplete>>, TError,{pathParams: MarkStreetsIncompletePathParameters;data: ManualMatchRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof markStreetsIncomplete>>, TError,{pathParams: MarkStreetsIncompletePathParameters;data: ManualMatchRequest}, TContext> => {

const mutationKey = ['markStreetsIncomplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markStreetsIncomplete>>, {pathParams: MarkStreetsIncompletePathParameters;data: ManualMatchRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  markStreetsIncomplete(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkStreetsIncompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markStreetsIncomplete>>>
    export type MarkStreetsIncompleteMutationBody = ManualMatchRequest
    export type MarkStreetsIncompleteMutationError = HTTPValidationError

    /**
 * @summary Mark Streets Incomplete
 */
export const useMarkStreetsIncomplete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markStreetsIncomplete>>, TError,{pathParams: MarkStreetsIncompletePathParameters;data: ManualMatchRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markStreetsIncomplete>>,
        TError,
        {pathParams: MarkStreetsIncompletePathParameters;data: ManualMatchRequest},
        TContext
      > => {

      const mutationOptions = getMarkStreetsIncompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Raw Strava run tracks for the workspace as a GeoJSON FeatureCollection.

Backs the optional "Strava runs" map overlay drawn on top of matched streets.
 * @summary List Strava Run Tracks
 */
export const listStravaRunTracks = (
    { workspaceId }: ListStravaRunTracksPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/workspaces/${workspaceId}/strava-runs`, method: 'GET', signal
    },
      options);
    }
  



export const getListStravaRunTracksQueryKey = ({ workspaceId }: ListStravaRunTracksPathParameters,) => {
    return [
    `/api/workspaces/${workspaceId}/strava-runs`
    ] as const;
    }

    
export const getListStravaRunTracksQueryOptions = <TData = Awaited<ReturnType<typeof listStravaRunTracks>>, TError = HTTPValidationError>({ workspaceId }: ListStravaRunTracksPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStravaRunTracksQueryKey({ workspaceId });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStravaRunTracks>>> = ({ signal }) => listStravaRunTracks({ workspaceId }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStravaRunTracksQueryResult = NonNullable<Awaited<ReturnType<typeof listStravaRunTracks>>>
export type ListStravaRunTracksQueryError = HTTPValidationError


export function useListStravaRunTracks<TData = Awaited<ReturnType<typeof listStravaRunTracks>>, TError = HTTPValidationError>(
 pathParams: ListStravaRunTracksPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaRunTracks>>,
          TError,
          Awaited<ReturnType<typeof listStravaRunTracks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaRunTracks<TData = Awaited<ReturnType<typeof listStravaRunTracks>>, TError = HTTPValidationError>(
 pathParams: ListStravaRunTracksPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStravaRunTracks>>,
          TError,
          Awaited<ReturnType<typeof listStravaRunTracks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStravaRunTracks<TData = Awaited<ReturnType<typeof listStravaRunTracks>>, TError = HTTPValidationError>(
 pathParams: ListStravaRunTracksPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Strava Run Tracks
 */

export function useListStravaRunTracks<TData = Awaited<ReturnType<typeof listStravaRunTracks>>, TError = HTTPValidationError>(
 { workspaceId }: ListStravaRunTracksPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStravaRunTracks>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStravaRunTracksQueryOptions({ workspaceId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Soft-delete (deactivate) streets by ID in the city. Admin only.
 * @summary Bulk Delete Streets
 */
export const bulkDeleteStreets = (
    { workspaceId }: BulkDeleteStreetsPathParameters,
    bulkDeleteRequest: BulkDeleteRequest,
 options?: SecondParameter<typeof makeRequest>,) => {
      
      
      return makeRequest<void>(
      {url: `/api/workspaces/${workspaceId}/streets`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest
    },
      options);
    }
  


export const getBulkDeleteStreetsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteStreets>>, TError,{pathParams: BulkDeleteStreetsPathParameters;data: BulkDeleteRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteStreets>>, TError,{pathParams: BulkDeleteStreetsPathParameters;data: BulkDeleteRequest}, TContext> => {

const mutationKey = ['bulkDeleteStreets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteStreets>>, {pathParams: BulkDeleteStreetsPathParameters;data: BulkDeleteRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  bulkDeleteStreets(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteStreetsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteStreets>>>
    export type BulkDeleteStreetsMutationBody = BulkDeleteRequest
    export type BulkDeleteStreetsMutationError = HTTPValidationError

    /**
 * @summary Bulk Delete Streets
 */
export const useBulkDeleteStreets = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteStreets>>, TError,{pathParams: BulkDeleteStreetsPathParameters;data: BulkDeleteRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteStreets>>,
        TError,
        {pathParams: BulkDeleteStreetsPathParameters;data: BulkDeleteRequest},
        TContext
      > => {

      const mutationOptions = getBulkDeleteStreetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List active streets for the workspace's city as a GeoJSON FeatureCollection.
 * @summary List Streets
 */
export const listStreets = (
    { workspaceId }: ListStreetsPathParameters,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/workspaces/${workspaceId}/streets`, method: 'GET', signal
    },
      options);
    }
  



export const getListStreetsQueryKey = ({ workspaceId }: ListStreetsPathParameters,) => {
    return [
    `/api/workspaces/${workspaceId}/streets`
    ] as const;
    }

    
export const getListStreetsQueryOptions = <TData = Awaited<ReturnType<typeof listStreets>>, TError = HTTPValidationError>({ workspaceId }: ListStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStreetsQueryKey({ workspaceId });

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStreets>>> = ({ signal }) => listStreets({ workspaceId }, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStreetsQueryResult = NonNullable<Awaited<ReturnType<typeof listStreets>>>
export type ListStreetsQueryError = HTTPValidationError


export function useListStreets<TData = Awaited<ReturnType<typeof listStreets>>, TError = HTTPValidationError>(
 pathParams: ListStreetsPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStreets>>,
          TError,
          Awaited<ReturnType<typeof listStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStreets<TData = Awaited<ReturnType<typeof listStreets>>, TError = HTTPValidationError>(
 pathParams: ListStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStreets>>,
          TError,
          Awaited<ReturnType<typeof listStreets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStreets<TData = Awaited<ReturnType<typeof listStreets>>, TError = HTTPValidationError>(
 pathParams: ListStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Streets
 */

export function useListStreets<TData = Awaited<ReturnType<typeof listStreets>>, TError = HTTPValidationError>(
 { workspaceId }: ListStreetsPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStreets>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStreetsQueryOptions({ workspaceId },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Suggest routes covering nearby uncovered streets from a start point.

Returns a GeoJSON FeatureCollection, one LineString Feature per candidate,
with properties {distance_m, new_km, new_streets}. May return fewer than
``count`` features (or none) when the start is off the network or little
uncovered street is within reach.
 * @summary Generate Suggested Routes
 */
export const generateSuggestedRoutes = (
    { workspaceId }: GenerateSuggestedRoutesPathParameters,
    suggestedRoutesRequest: SuggestedRoutesRequest,
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<FeatureCollection>(
      {url: `/api/workspaces/${workspaceId}/suggested-routes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: suggestedRoutesRequest, signal
    },
      options);
    }
  


export const getGenerateSuggestedRoutesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSuggestedRoutes>>, TError,{pathParams: GenerateSuggestedRoutesPathParameters;data: SuggestedRoutesRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof generateSuggestedRoutes>>, TError,{pathParams: GenerateSuggestedRoutesPathParameters;data: SuggestedRoutesRequest}, TContext> => {

const mutationKey = ['generateSuggestedRoutes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateSuggestedRoutes>>, {pathParams: GenerateSuggestedRoutesPathParameters;data: SuggestedRoutesRequest}> = (props) => {
          const {pathParams,data} = props ?? {};

          return  generateSuggestedRoutes(pathParams,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateSuggestedRoutesMutationResult = NonNullable<Awaited<ReturnType<typeof generateSuggestedRoutes>>>
    export type GenerateSuggestedRoutesMutationBody = SuggestedRoutesRequest
    export type GenerateSuggestedRoutesMutationError = HTTPValidationError

    /**
 * @summary Generate Suggested Routes
 */
export const useGenerateSuggestedRoutes = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateSuggestedRoutes>>, TError,{pathParams: GenerateSuggestedRoutesPathParameters;data: SuggestedRoutesRequest}, TContext>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateSuggestedRoutes>>,
        TError,
        {pathParams: GenerateSuggestedRoutesPathParameters;data: SuggestedRoutesRequest},
        TContext
      > => {

      const mutationOptions = getGenerateSuggestedRoutesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Health check endpoint
 * @summary Health Check
 */
export const healthCheck = (
    
 options?: SecondParameter<typeof makeRequest>,signal?: AbortSignal
) => {
      
      
      return makeRequest<unknown>(
      {url: `/health`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthCheckQueryKey = () => {
    return [
    `/health`
    ] as const;
    }

    
export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = unknown


export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health Check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>>, request?: SecondParameter<typeof makeRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
